export default __webpack_public_path__ + "static/media/guardianloginportal.93d6f49f.PNG";